import { Layout as AntLayout, Space } from 'antd';
import { Header, SideBar } from 'components';
import { ResultError } from 'components/errors';
import { NotificationDocuments } from 'components/notification/notification-documents';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
import { useUserContext } from 'features/users';
import { useSideBar } from 'providers/side-bar-provider';
import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';

import { StyledLayout } from './layout.styles';

export const Layout = () => {
  const { collapsed, notificationCollapsed } = useSideBar();
  const { Content } = AntLayout;
  const [notification, SetNotification] = useState<any>(null);
  const { user } = useUserContext();
  const initial = async () => {
    try {
      const apiRes = await DashBoardApiService().GetNotifications({
        CompanyId: user?.CompanyId,
      } as any);
      SetNotification(apiRes);
    } catch (error) {
      console.error('Error fetchings client status graph:', error);
    }
  };
  useEffect(() => {
    initial();
  }, []);
  
return (
    <StyledLayout
      $collapsed={collapsed}
      $notificationCollapsed={notificationCollapsed}
    >
      <Header refetch={initial} />

      <AntLayout>
        <SideBar />
        <Content className='layout-content'>
          <ErrorBoundary FallbackComponent={ResultError}>
            <Space className='layout-space relative'>
              <Outlet />
            </Space>
          </ErrorBoundary>
        </Content>
        {/* any error then remove  */}
        <NotificationDocuments notification={notification} refetch={initial} />
      </AntLayout>
    </StyledLayout>
  );
};
